var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFolderHollow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27051 5.05469C3.13244 5.05469 3.02051 5.16662 3.02051 5.30469V16.3047C3.02051 16.4428 3.13244 16.5547 3.27051 16.5547H16.7705C16.9086 16.5547 17.0205 16.4428 17.0205 16.3047V7.17969C17.0205 7.04162 16.9086 6.92969 16.7705 6.92969H10.0205C9.8879 6.92969 9.76072 6.87701 9.66695 6.78324L7.9384 5.05469H3.27051ZM2.02051 5.30469C2.02051 4.61433 2.58015 4.05469 3.27051 4.05469H8.14551C8.27812 4.05469 8.40529 4.10737 8.49906 4.20113L10.2276 5.92969H16.7705C17.4609 5.92969 18.0205 6.48933 18.0205 7.17969V16.3047C18.0205 16.995 17.4609 17.5547 16.7705 17.5547H3.27051C2.58015 17.5547 2.02051 16.995 2.02051 16.3047V5.30469Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFolderHollow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/folder-hollow.9467c733edb3c1833d647c39ec6995de.svg";